import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=c84da972&scoped=true"
import script from "./fans.vue?vue&type=script&lang=js"
export * from "./fans.vue?vue&type=script&lang=js"
import style0 from "./fans.vue?vue&type=style&index=0&id=c84da972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84da972",
  null
  
)

export default component.exports